<template>
    <div style="height:100%" class="row">
        <div style="width:480px; flex-shrink:0">

            <fieldset>
                <legend>加载孔位</legend>
                <div class="param-row">
                    <label>NC文件:</label>
                    <input ref="fileinput" type="file" @change="onFileInput">
                </div>
                <button @click="loadNC">从NC文件中加载孔位置</button>
                <button @click="showPaste = true" style="margin-left:4px">粘贴NC内容</button>
                <div v-show="showPaste" style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:999; display:flex; align-items:center; justify-content:center" @click.self="showPaste = false">
                    <div style="background:#fff; padding:16px; border-radius:6px; width:600px; max-height:80%">
                        <div style="margin-bottom:8px; font-weight:bold">粘贴 NC 代码（手动 Ctrl+V 粘贴到下方文本框）</div>
                        <textarea ref="pasteArea" style="width:100%; height:300px; font-family:monospace; font-size:12px; box-sizing:border-box" placeholder="在此粘贴 NC 代码..."></textarea>
                        <div style="margin-top:8px; text-align:right">
                            <button @click="showPaste = false" style="margin-right:8px">取消</button>
                            <button @click="doPasteNC">确认加载</button>
                        </div>
                    </div>
                </div>
            </fieldset>

            <fieldset>
                <legend>孔位列表</legend>
                <div class="param-row">
                    <label>孔数量:</label>
                    <span>{{holes.length}}</span>
                    <button @click="newHole">+</button>
                </div>
                <div class="param-row" v-for="(hole,h) in holes" :key="h">
                    <input type="checkbox" v-model="hole.selected" style="flex-shrink:0" />
                    <label style="width:45px">孔 {{h+1}}:</label>
                    X<NumberInput v-model="hole.x" style="width:55px" @paste-pair="([x, y]) => { hole.x = x; hole.y = y }" />
                    Y<NumberInput v-model="hole.y" style="width:55px" @paste-pair="([x, y]) => { hole.x = x; hole.y = y }" />
                    <button @click="removeHole(h)" title="删除" style="padding:0 3px; white-space:nowrap; color:#c00">✕</button>
                    <button @click="copyHole(h)" title="克隆行" style="padding:0 3px; white-space:nowrap">⧉</button>
                    <button @click="copyCoord(h)" title="复制坐标" style="padding:0 3px; white-space:nowrap">📋</button>
                </div>
                <div class="param-row" style="margin-top:4px">
                    <label></label>
                    <button @click="deleteSelected" title="删除选中">🗑</button>
                    <button @click="selectAllHoles" title="全选">☑</button>
                    <button @click="deselectAllHoles" title="取消选择">☐</button>
                    <button @click="invertSelection" title="反选">↻</button>
                    <button @click="showArray = true" :disabled="!selectedCount" title="阵列">⊞</button>
                </div>
                <!-- 阵列对话框 -->
                <div v-if="showArray" style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:999; display:flex; align-items:center; justify-content:center" @click.self="showArray = false">
                    <div style="background:#fff; padding:16px; border-radius:6px; width:360px">
                        <div style="margin-bottom:8px; font-weight:bold">阵列参数（{{selectedCount}} 个参考孔）</div>
                        <div class="param-row"><label>列数:</label><NumberInput v-model="arrayCols" style="width:60px" /><label style="width:auto; margin-left:8px">间距:</label><NumberInput v-model="arrayColSpacing" style="width:60px" /><span class="hint">mm</span></div>
                        <div class="param-row"><label>行数:</label><NumberInput v-model="arrayRows" style="width:60px" /><label style="width:auto; margin-left:8px">间距:</label><NumberInput v-model="arrayRowSpacing" style="width:60px" /><span class="hint">mm</span></div>
                        <div class="param-row"><label>预计新增:</label><span>{{ selectedCount * (arrayRows * arrayCols - 1) }} 孔</span></div>
                        <div style="margin-top:8px; text-align:right">
                            <button @click="showArray = false" style="margin-right:8px">取消</button>
                            <button @click="doArray">确认</button>
                        </div>
                    </div>
                </div>
            </fieldset>

            <fieldset>
                <legend>钻孔参数</legend>
                <div class="param-row">
                    <label>类型:</label>
                    <select v-model="drillType" style="width:130px">
                        <option value="peck">G83 啄钻(钻孔)</option>
                        <option value="ream">G01 铰孔</option>
                        <option value="chamfer">G81 孔口倒角</option>
                    </select>
                </div>
                <div class="param-row" v-if="drillType === 'peck'">
                    <label>Q (啄钻增量):</label>
                    <NumberInput v-model="Q" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
                <div class="param-row" v-if="drillType === 'ream'">
                    <label>孔底暂停:</label>
                    <NumberInput v-model="reamDwell" style="width:60px" />
                    <span class="hint">秒</span>
                </div>
                <div class="param-row" v-if="drillType === 'ream'">
                    <label>退刀转速%:</label>
                    <NumberInput v-model="reamRetractSpindleRatio" style="width:60px" />
                    <span class="hint">%（进给转速的百分比）</span>
                </div>
                <div class="param-row" v-if="drillType === 'ream'">
                    <label>退刀速度:</label>
                    <NumberInput v-model="reamRetractFeed" style="width:60px" />
                    <span class="hint">mm/min（留空=使用进给速度）</span>
                </div>
                <div class="param-row" v-if="drillType === 'ream'">
                    <label>
                        <input type="checkbox" v-model="reamSegmentEnable" /> 分段暂停
                    </label>
                    <span v-if="reamSegmentEnable">每</span>
                    <NumberInput v-if="reamSegmentEnable" v-model="reamSegmentDepth" style="width:50px" />
                    <span v-if="reamSegmentEnable" class="hint">mm 暂停</span>
                </div>
                <div class="param-row" v-if="drillType === 'ream'">
                    <label>孔后暂停:</label>
                    <NumberInput v-model="reamPostDwell" style="width:60px" />
                    <span class="hint">秒（退到R后清屑/上油）</span>
                </div>
                <div class="param-row" v-if="drillType === 'chamfer'">
                    <label>刀尖角度:</label>
                    <NumberInput v-model="chamferTipAngle" style="width:60px" />
                    <span class="hint">°</span>
                </div>
                <div class="param-row" v-if="drillType === 'chamfer'">
                    <label>孔径:</label>
                    <NumberInput v-model="chamferHoleDiameter" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
                <div class="param-row" v-if="drillType === 'chamfer'">
                    <label>倒角半径:</label>
                    <NumberInput v-model="chamferRadius" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
                <div class="param-row">
                    <label>R (开始深度):</label>
                    <NumberInput v-model="R" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
                <div class="param-row" v-if="drillType === 'chamfer'">
                    <label>Z (倒角深度):</label>
                    <NumberInput v-model="chamferZValue" style="width:60px" />
                    <button @click="updateChamferZ" style="padding:0 4px; font-size:12px" title="根据孔径、刀尖角度、倒角半径计算Z">=</button>
                    <span class="hint">mm</span>
                </div>
                <div class="param-row" v-else>
                    <label>Z (最终深度):</label>
                    <NumberInput v-model="z" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
            </fieldset>

            <fieldset>
                <legend>加工参数</legend>
                <div class="param-row">
                    <label>进给:</label>
                    <NumberInput v-model="feed" style="width:80px" />
                    <span class="hint">mm/min</span>
                </div>
                <div class="param-row">
                    <label>转速:</label>
                    <NumberInput v-model="spindleRPM" style="width:80px" />
                    <span class="hint">RPM</span>
                </div>
                <div class="param-row">
                    <label>安全高度:</label>
                    <NumberInput v-model="safeZ" style="width:80px" />
                    <span class="hint">mm</span>
                </div>
            </fieldset>

            <fieldset v-if="drillType === 'peck'">
                <legend>钻尖过量计算</legend>
                <div class="param-row">
                    <label>钻头角度:</label>
                    <NumberInput v-model="drillAngle" style="width:60px" />
                    <span class="hint">°</span>
                </div>
                <div class="param-row">
                    <label>钻头直径:</label>
                    <NumberInput v-model="drillDiameter" style="width:60px" />
                    <span class="hint">mm</span>
                </div>
                <div class="param-row">
                    <label>钻尖高度:</label>
                    <span style="font-weight:bold">{{ drillTipHeight.toFixed(3) }}</span>
                    <span class="hint">mm</span>
                </div>
            </fieldset>

            <fieldset>
                <legend>生成</legend>
                <div class="param-row">
                    <label style="width:auto">
                        <input type="checkbox" v-model="positionOnly" /> 仅定位
                    </label>
                    <span class="hint" v-if="positionOnly">停留</span>
                    <NumberInput v-if="positionOnly" v-model="dwellTime" style="width:50px" />
                    <span class="hint" v-if="positionOnly">秒</span>
                </div>
                <button @click="generateSelectedNC" :disabled="!selectedCount">选中孔生成NC</button>
                <button @click="generateNC" style="margin-left:4px">所有孔生成NC</button>
            </fieldset>

        </div>
        <div class="col" style="flex:1; position:relative; overflow:hidden; min-width:200px">
            <svg
                width="100%" height="100%"
                :viewBox="viewBox"
                preserveAspectRatio="xMidYMid meet"
                style="background:#f5f5f5; display:block"
            >
                <!-- 坐标轴线 -->
                <line :x1="bounds.x" :y1="0" :x2="bounds.x + bounds.w" :y2="0" stroke="#ccc" stroke-width="0.3" />
                <line :x1="0" :y1="bounds.y" :x2="0" :y2="bounds.y + bounds.h" stroke="#ccc" stroke-width="0.3" />

                <!-- 原点标记 -->
                <line x1="-5" y1="0" x2="5" y2="0" stroke="#e67e00" stroke-width="0.3" />
                <line x1="0" y1="-5" x2="0" y2="5" stroke="#e67e00" stroke-width="0.3" />

                <!-- 孔位标记（Y轴向上：CNC +Y = 屏幕上方） -->
                <g v-for="(hole, h) in holes" :key="h">
                    <circle :cx="hole.x" :cy="-hole.y" r="1.8" fill="none" :stroke="hole.selected ? '#e67e00' : '#1a6fc4'" stroke-width="0.5" />
                    <line :x1="hole.x - 2.5" :y1="-hole.y" :x2="hole.x + 2.5" :y2="-hole.y" :stroke="hole.selected ? '#e67e00' : '#1a6fc4'" stroke-width="0.4" />
                    <line :x1="hole.x" :y1="-hole.y - 2.5" :x2="hole.x" :y2="-hole.y + 2.5" :stroke="hole.selected ? '#e67e00' : '#1a6fc4'" stroke-width="0.4" />
                    <text :x="hole.x + 3" :y="-hole.y - 2.5" :fill="hole.selected ? '#e67e00' : '#1a6fc4'" font-size="3.5" text-anchor="start">{{ h + 1 }}</text>
                </g>
            </svg>
        </div>
    </div>
</template>


<script>
import { ref, reactive, inject, watch, computed } from "vue";
import { readFileAsText, parseFileName } from "../util/browser-fs.js";
import { fmtNC } from "../util/nc-format.js";
import NumberInput from "./NumberInput.vue";

const STORAGE_KEY = "nc-helper-drill-state";

// 支持的钻孔/镗孔固定循环
const DRILL_CYCLES = ["G73", "G81", "G82", "G83", "G85", "G86"];

export default {
    components: { NumberInput },
    setup() {
        const fileManager = inject("fileManager");

        function loadState() {
            try {
                const saved = localStorage.getItem(STORAGE_KEY);
                return saved ? JSON.parse(saved) : null;
            } catch {
                return null;
            }
        }

        function saveState(state) {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
            } catch {
                // 静默忽略存储错误
            }
        }

        const saved = loadState();

        const holes = reactive(saved?.holes ?? []);
        const Q = ref(saved?.Q ?? 0.15);
        const R = ref(saved?.R ?? 0.2);
        const z = ref(saved?.z ?? -3);
        const feed = ref(saved?.feed ?? 50);
        const spindleRPM = ref(saved?.spindleRPM ?? 6000);
        const safeZ = ref(saved?.safeZ ?? 10);
        const positionOnly = ref(saved?.positionOnly ?? false);
        const dwellTime = ref(saved?.dwellTime ?? 1);
        const drillType = ref(saved?.drillType ?? "peck");
        const chamferTipAngle = ref(saved?.chamferTipAngle ?? 90);
        const chamferHoleDiameter = ref(saved?.chamferHoleDiameter ?? 3);
        const chamferRadius = ref(saved?.chamferRadius ?? 0.5);
        const chamferZValue = ref(saved?.chamferZValue ?? -1);

        function autoChamferZ(diameter, angle, radius) {
            if (!diameter || diameter <= 0 || !angle || angle <= 0) return 0;
            const halfAngle = (angle / 2) * Math.PI / 180;
            const raw = -(diameter / 2) / Math.tan(halfAngle) - radius;
            return Math.round(raw * 10000) / 10000;
        }

        function updateChamferZ() {
            chamferZValue.value = autoChamferZ(chamferHoleDiameter.value, chamferTipAngle.value, chamferRadius.value);
        }
        watch([chamferHoleDiameter, chamferTipAngle, chamferRadius], updateChamferZ);
        const reamDwell = ref(saved?.reamDwell ?? 1);
        const reamRetractSpindleRatio = ref(saved?.reamRetractSpindleRatio ?? 10);
        const reamRetractFeed = ref(saved?.reamRetractFeed ?? 50);
        const reamPostDwell = ref(saved?.reamPostDwell ?? 0);
        const reamSegmentEnable = ref(saved?.reamSegmentEnable ?? false);
        const reamSegmentDepth = ref(saved?.reamSegmentDepth ?? 5);
        const drillAngle = ref(saved?.drillAngle ?? 118);
        const drillDiameter = ref(saved?.drillDiameter ?? 3);
        const fileinput = ref(null);
        const pasteArea = ref(null);
        const showPaste = ref(false);
        const showArray = ref(false);
        const arrayRows = ref(2);
        const arrayCols = ref(2);
        const arrayRowSpacing = ref(10);
        const arrayColSpacing = ref(10);
        const _outputFilename = ref(saved?._outputFilename ?? null);

        const selectedCount = computed(() => holes.filter(h => h.selected).length);

        const bounds = computed(() => {
            if (holes.length === 0) return { x: -60, y: -60, w: 120, h: 120 };
            let minX = Infinity, maxX = -Infinity;
            let minY = Infinity, maxY = -Infinity;
            for (const h of holes) {
                if (h.x < minX) minX = h.x;
                if (h.x > maxX) maxX = h.x;
                if (h.y < minY) minY = h.y;
                if (h.y > maxY) maxY = h.y;
            }
            if (0 < minX) minX = 0;
            if (0 > maxX) maxX = 0;
            if (0 < minY) minY = 0;
            if (0 > maxY) maxY = 0;
            const padX = Math.max((maxX - minX) * 0.2, 15);
            const padY = Math.max((maxY - minY) * 0.2, 15);
            return {
                x: minX - padX,
                y: -(maxY + padY),      // Y翻转：CNC +Y朝上 → SVG +Y朝下
                w: maxX - minX + padX * 2,
                h: maxY - minY + padY * 2,
            };
        });

        const viewBox = computed(() => {
            const b = bounds.value;
            return `${b.x} ${b.y} ${b.w} ${b.h}`;
        });

        const drillTipHeight = computed(() => {
            if (!drillDiameter.value || drillDiameter.value <= 0) return 0;
            const halfAngle = (drillAngle.value / 2) * Math.PI / 180;
            const raw = (drillDiameter.value / 2) / Math.tan(halfAngle);
            return Math.round(raw * 10000) / 10000;
        });

        watch(
            () => ({
                holes: holes.map(h => ({ x: h.x, y: h.y })),
                Q: Q.value,
                R: R.value,
                z: z.value,
                feed: feed.value,
                spindleRPM: spindleRPM.value,
                safeZ: safeZ.value,
                positionOnly: positionOnly.value,
                drillType: drillType.value,
                chamferHoleDiameter: chamferHoleDiameter.value,
                chamferTipAngle: chamferTipAngle.value,
                chamferRadius: chamferRadius.value,
                chamferZValue: chamferZValue.value,
                reamDwell: reamDwell.value,
                reamRetractSpindleRatio: reamRetractSpindleRatio.value,
                reamRetractFeed: reamRetractFeed.value,
                reamSegmentEnable: reamSegmentEnable.value,
                reamSegmentDepth: reamSegmentDepth.value,
                reamPostDwell: reamPostDwell.value,
                dwellTime: dwellTime.value,
                drillAngle: drillAngle.value,
                drillDiameter: drillDiameter.value,
                _outputFilename: _outputFilename.value,
            }),
            (state) => saveState(state),
            { deep: true }
        );

        return {
            holes,
            Q,
            R,
            z,
            feed,
            spindleRPM,
            safeZ,
            positionOnly,
            drillType,
            chamferHoleDiameter,
            chamferTipAngle,
            chamferRadius,
            chamferZValue,
            updateChamferZ,
            reamDwell,
            reamRetractSpindleRatio,
            reamRetractFeed,
            reamSegmentEnable,
            reamSegmentDepth,
            reamPostDwell,
            dwellTime,
            drillAngle,
            drillDiameter,
            drillTipHeight,
            fileinput,
            pasteArea,
            showPaste,
            showArray,
            arrayRows,
            arrayCols,
            arrayRowSpacing,
            arrayColSpacing,
            selectedCount,
            _outputFilename,
            fileManager,
            bounds,
            viewBox,
        };
    },

    methods: {
        newHole() {
            this.holes.push({ x: 0, y: 0, selected: false });
        },
        removeHole(h) {
            this.holes.splice(h, 1);
        },
        copyHole(h) {
            this.holes.splice(h, 0, {
                x: this.holes[h].x,
                y: this.holes[h].y,
                selected: false,
            });
        },
        copyCoord(h) {
            navigator.clipboard.writeText(this.holes[h].x + "," + this.holes[h].y);
        },

        deleteSelected() {
            const count = this.holes.filter(h => h.selected).length;
            if (count === 0) return;
            if (!confirm(`确认删除选中的 ${count} 个孔？`)) return;
            for (let i = this.holes.length - 1; i >= 0; i--) {
                if (this.holes[i].selected) this.holes.splice(i, 1);
            }
        },

        selectAllHoles() {
            this.holes.forEach(h => h.selected = true);
        },

        deselectAllHoles() {
            this.holes.forEach(h => h.selected = false);
        },

        invertSelection() {
            this.holes.forEach(h => h.selected = !h.selected);
        },

        doArray() {
            const rows = this.arrayRows;
            const cols = this.arrayCols;
            const rSpacing = this.arrayRowSpacing;
            const cSpacing = this.arrayColSpacing;
            if (rows < 1 || cols < 1) return;
            if (rows === 1 && cols === 1) {
                this.showArray = false;
                return;
            }

            // 列优先：逐列、逐参考孔（按列表顺序）、逐行生成，追加到末尾
            const allNewHoles = [];
            const refs = this.holes.filter(h => h.selected);
            for (let c = 0; c < cols; c++) {
                for (const ref of refs) {
                    for (let r = 0; r < rows; r++) {
                        if (r === 0 && c === 0) continue;
                        allNewHoles.push({
                            x: ref.x + c * cSpacing,
                            y: ref.y + r * rSpacing,
                            selected: false,
                        });
                    }
                }
            }
            this.holes.push(...allNewHoles);

            this.showArray = false;
        },

        parseNC(nc) {
            const lines = nc.split("\n");
            const loc = { X: NaN, Y: NaN };
            let abs = true;
            let activeCycle = null;
            const holes = [];

            for (let l = 0; l < lines.length; l++) {
                const line = lines[l].trim();
                if (!line || line.startsWith("(") || line.startsWith(";")) continue;

                // 绝对/增量坐标
                if (line.match(/\bG90\b/)) abs = true;
                if (line.match(/\bG91\b/)) abs = false;

                // G 代码检测
                const gMatches = line.match(/G(\d+)/g);
                if (gMatches) {
                    for (const g of gMatches) {
                        const gn = g.slice(1);
                        if (DRILL_CYCLES.includes(g)) {
                            activeCycle = g;
                        } else if (gn === "80") {
                            activeCycle = null;  // 取消固定循环
                        } else {
                            // 其他 G 代码（G00/G01 等）不改变 activeCycle
                        }
                    }
                }

                // 提取 X/Y 坐标
                let xyChanged = false;
                const xMatch = line.match(/[Xx](-?\d*\.?\d*)/);
                const yMatch = line.match(/[Yy](-?\d*\.?\d*)/);

                if (xMatch) {
                    const n = parseFloat(xMatch[1]);
                    loc.X = abs ? n : (isNaN(loc.X) ? 0 : loc.X) + n;
                    xyChanged = true;
                }
                if (yMatch) {
                    const n = parseFloat(yMatch[1]);
                    loc.Y = abs ? n : (isNaN(loc.Y) ? 0 : loc.Y) + n;
                    xyChanged = true;
                }

                // 固定循环激活中且坐标有变化 → 记录孔位
                if (activeCycle && xyChanged && !isNaN(loc.X) && !isNaN(loc.Y)) {
                    holes.push({ x: loc.X, y: loc.Y, selected: false });
                }
            }

            return holes;
        },

        async loadNC() {
            if (!this.$refs.fileinput.files[0]) {
                alert("请选择NC文件");
                return;
            }

            let nc;
            try {
                nc = await readFileAsText(this.$refs.fileinput);
            } catch (e) {
                alert("读取文件失败：" + e.message);
                console.error(e);
                return;
            }

            const holes = this.parseNC(nc);
            if (holes.length === 0) {
                alert("未能从NC文件中找到钻孔定位孔（G73/G81/G82/G83/G85/G86）");
                return;
            }
            // 替换孔列表
            this.holes.splice(0, this.holes.length, ...holes);
        },

        doPasteNC() {
            const text = this.$refs.pasteArea?.value;
            if (!text || !text.trim()) {
                alert("请先在文本框中粘贴 NC 代码");
                return;
            }

            const holes = this.parseNC(text);
            if (holes.length === 0) {
                alert("未能从粘贴内容中找到钻孔定位孔（G73/G81/G82/G83/G85/G86）");
                return;
            }
            // 替换孔列表
            this.holes.splice(0, this.holes.length, ...holes);
            this.$refs.pasteArea.value = "";
            this.showPaste = false;
        },

        onFileInput() {
            if (this.$refs.fileinput.files[0]) {
                const pathinfo = parseFileName(
                    this.$refs.fileinput.files[0].name
                );
                // 生成建议的输出文件名
                this._outputFilename = `${pathinfo.name}-drill${pathinfo.ext}`;
            }
        },

        generateNCForHoles(holes, label) {
            if (holes.length === 0) {
                alert("错误：孔位列表为空");
                return;
            }

            const dz = this.drillType === "chamfer" ? this.chamferZValue : this.z;
            if (!this.positionOnly && this.R <= dz) {
                alert("错误：R（开始深度）必须大于 Z（最终深度）");
                return;
            }

            const now = new Date();
            const ts = now.getFullYear() + "-"
                + String(now.getMonth() + 1).padStart(2, "0") + "-"
                + String(now.getDate()).padStart(2, "0") + " "
                + String(now.getHours()).padStart(2, "0") + ":"
                + String(now.getMinutes()).padStart(2, "0") + ":"
                + String(now.getSeconds()).padStart(2, "0");

            const typeLabel = { peck: "G83钻孔", ream: "G01铰孔", chamfer: "G81孔口倒角" }[this.drillType];
            let nc = `(${typeLabel}${label ? " " + label : ""}  生成时间: ${ts})\n`;
            nc += `(孔数=${holes.length}  R[开始深度]=${this.R}mm  Z[深度]=${dz}mm)\n`;
            if (this.drillType === "peck") nc += `(Q[啄钻增量]=${this.Q}mm)\n`;
            if (this.drillType === "ream") {
                nc += `(孔底暂停=${this.reamDwell}秒  退刀转速=${this.reamRetractSpindleRatio > 0 ? Math.round(this.spindleRPM * this.reamRetractSpindleRatio / 100) + 'RPM' : 'M05关停'}`;
                nc += `  退刀速度=${this.reamRetractFeed}mm/min`;
                if (this.reamSegmentEnable) nc += `  分段暂停每${Math.abs(this.reamSegmentDepth)}mm`;
                if (this.reamPostDwell > 0) nc += `  孔后清屑暂停=${this.reamPostDwell}秒`;
                nc += `)\n`;
            }
            if (this.drillType === "chamfer") nc += `(孔径=${this.chamferHoleDiameter}mm  刀尖角度=${this.chamferTipAngle}°  倒角半径=${this.chamferRadius}mm)\n`;
            nc += `(安全高度=${this.safeZ}mm  主轴=${this.spindleRPM}RPM  进给=${this.feed}mm/min)\n`;
            if (this.positionOnly) {
                nc += `(仅定位模式  停留${this.dwellTime}秒)\n`;
            }
            nc += `%\nG90 G54\nG0 Z${fmtNC(this.safeZ)} S${this.spindleRPM} M03`;
            for (let hole of holes) {
                if (this.positionOnly) {
                    nc += "\nG0 X" + fmtNC(hole.x) + " Y" + fmtNC(hole.y);
                    nc += "\nG0 Z" + fmtNC(this.R);
                    nc += "\nG4 P" + fmtNC(this.dwellTime * 1000, 0);
                } else if (this.drillType === "ream") {
                    const ratio = this.reamRetractSpindleRatio;
                    const retractRPM = Math.round(this.spindleRPM * ratio / 100);
                    const retractFeed = this.reamRetractFeed > 0 ? this.reamRetractFeed : this.feed;
                    const dwellMs = Math.round(this.reamDwell * 1000);
                    const postDwellMs = Math.round(this.reamPostDwell * 1000);
                    nc += "\nG0 X" + fmtNC(hole.x) + " Y" + fmtNC(hole.y);
                    nc += "\nS" + this.spindleRPM + " M03";
                    nc += "\nG0 Z" + fmtNC(this.R);
                    if (this.reamSegmentEnable && this.reamSegmentDepth > 0) {
                        let z = this.R;
                        while (z > dz) {
                            z -= this.reamSegmentDepth;
                            if (z < dz) z = dz;
                            nc += "\nG1 Z" + fmtNC(z) + " F" + fmtNC(this.feed);
                            if (z > dz) nc += "\nG4 P" + dwellMs;
                        }
                    } else {
                        nc += "\nG1 Z" + fmtNC(dz) + " F" + fmtNC(this.feed);
                    }
                    nc += "\nG4 P" + dwellMs;
                    if (ratio <= 0) {
                        nc += "\nM05";
                    } else {
                        nc += "\nS" + retractRPM + " M03";
                    }
                    nc += "\nG1 Z" + fmtNC(this.R) + " F" + fmtNC(retractFeed);
                    if (postDwellMs > 0) {
                        nc += "\nS0 M03";
                        nc += "\nG4 P" + postDwellMs;
                    }
                } else if (this.drillType === "chamfer") {
                    nc += "\nG0 X" + fmtNC(hole.x) + " Y" + fmtNC(hole.y);
                    nc += "\nG0 Z" + fmtNC(this.R);
                    nc += "\nG81 X" + fmtNC(hole.x) + " Y" + fmtNC(hole.y) + " Z" + fmtNC(dz) + " R" + fmtNC(this.R) + " F" + fmtNC(this.feed);
                } else {
                    nc += "\nG0 X" + fmtNC(hole.x) + " Y" + fmtNC(hole.y);
                    nc += "\nG0 Z" + fmtNC(this.R);
                    nc += "\nG83 Z" + fmtNC(dz) + " R" + fmtNC(this.R) + " Q" + fmtNC(this.Q) + " F" + fmtNC(this.feed);
                }
                nc += "\nG0 Z" + fmtNC(this.safeZ);
            }

            nc += "\nM05\nM30\n%";

            const filename = this._outputFilename || "drill.nc";
            this.fileManager.addFileTab(filename, nc);
        },

        generateNC() {
            this.generateNCForHoles(this.holes);
        },

        generateSelectedNC() {
            const selected = this.holes.filter(h => h.selected);
            if (selected.length === 0) {
                alert("错误：没有选中的孔");
                return;
            }
            this.generateNCForHoles(selected, "选中孔");
        },
    },
};
</script>

<style scoped>
.param-row label {
    width: 100px;
}
</style>
